import { Link } from "react-router-dom";
import { Twitter, Linkedin, Youtube, Mail } from "lucide-react";
import { Logo } from "@/components/Logo";

const COLS = [
  {
    title: "Product",
    links: [
      { label: "Live tool", to: "/" },
      { label: "How it works", to: "/how-it-works" },
      { label: "Pricing", to: "/pricing" },
      { label: "Refer a friend", to: "/referrals" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Blog", to: "/blog" },
      { label: "FAQ", to: "/faq" },
      { label: "Contact", to: "/contact" },
    ],
  },
];

const SOCIALS = [
  { icon: Twitter, label: "X / Twitter", href: "https://twitter.com" },
  { icon: Linkedin, label: "LinkedIn", href: "https://linkedin.com" },
  { icon: Youtube, label: "YouTube", href: "https://youtube.com" },
  { icon: Mail, label: "Email", href: "/contact" },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-surface/40" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <Logo />
            <p className="mt-5 text-mist max-w-sm leading-relaxed">
              The browser-native status engine. Keep your screen awake and your dot green — on Teams,
              Slack, Zoom and every platform in between.
            </p>
            <div className="mt-7 flex items-center gap-3">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target={s.href.startsWith("http") ? "_blank" : undefined}
                  rel="noreferrer"
                  aria-label={s.label}
                  data-testid={`footer-social-${s.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-mist transition-colors hover:text-neon hover:border-neon/50"
                >
                  <s.icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {COLS.map((col) => (
            <div key={col.title} className="md:col-span-3">
              <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-dim mb-5">{col.title}</p>
              <ul className="space-y-3.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to} className="text-mist hover:text-neon transition-colors" data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-7 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-dim text-xs" data-testid="footer-copyright">© 2026 Jiggly. All rights reserved.</p>
          <p className="text-dim text-xs max-w-md" data-testid="footer-affiliation-note">
            Jiggly is an independent utility and is not affiliated with Microsoft, Slack, Zoom or Google.
          </p>
        </div>
      </div>
    </footer>
  );
}
